<template>
    <div class="stats-page">
        <button class="back" @click="$router.push({ name: 'Cameras'})"></button>
        <h1>App Stats</h1>
        <button class="reset-btn" @click="$store.dispatch('resetStats')">Reset</button>
        <!-- <div class="refresh-group">
            <button class="refresh-btn" @click="requestUpdate"></button>
            <p>Updated {{ updatedMessage }}</p>
        </div> -->
        <div class="table-wrapper">
            <div class="loading-wrapper" v-if="loading === true">
                <LoadingWheel />
            </div>
            <div class="stats-table">
                <div class="row" v-bind:key="key" v-for="(value, key) in appStats">
                    <p> {{ key }} </p>
                    <p> {{ value }} </p>
                </div>
            </div>
            <!-- <table class="stats-table"
        cellspacing="0" cellpadding="0">
          <tr v-bind:key="key" v-for="(value, key) in stats">
            <td class="left-text-align">{{ key }}</td>
            <td class="right-text-align">{{ value }}</td>
          </tr>
        </table>-->
        </div>
    </div>
</template>

<script>
import relativeTime from '@/utils/relativeTime';
import LoadingWheel from '@/components/LoadingWheel.vue';

export default {
  name: 'DeviceStats',
  props: ['device'],
  components: {
    LoadingWheel,
  },
  data() {
    return {
      lastUpdated: 0,
      updatedMessage: 'just now',
      deviceName: '',
      deviceId: '',
      stats: {},
      timerId: -1,
      interval: 5000,
      loading: false,
    };
  },
  computed: {
    appStats() {
      return this.$store.getters.statData;
    },
  },
  filters: {
    relativeTimeFilter(input) {
      const startTime = Number.parseInt(input, 10);
      if (Number.isNaN(startTime)) return input;
      return relativeTime(input, Date.now());
    },
  },
  mounted() {
    /* this.deviceId = this.$route.params.device;
        this.deviceName = this.$route.params.name; */
    // this.$emit('requestStats');
    // this.setStatsData(this.$store.stats);
  },
  beforeDestroy() {
    this.stopTimer();
  },
  methods: {
    setAppData(data) {
      this.loading = false;
      this.stats = data;
      this.lastUpdated = Date.now();
    },
    setStatsData(data) {
      this.loading = false;
      this.lastUpdated = Date.now();
      this.updatedMessage = relativeTime(this.lastUpdated, this.lastUpdated);
      this.stats = data;
      this.setInterval(5000);
      this.startTimer();
    },
    requestUpdate() {
      this.loading = true;
      this.stopTimer();
      this.$emit('requestStats');
    },
    setInterval(interval) {
      this.interval = interval;
    },
    startTimer() {
      if (this.timerId !== -1) this.stopTimer();
      this.timerId = setInterval(this.handleTimer, this.interval);
    },
    handleTimer() {
      const current = Date.now();
      this.updatedMessage = relativeTime(this.lastUpdated, current);
      if (current - this.lastUpdated > 60 * 1000 && this.interval === 5000) {
        this.stopTimer();
        this.setInterval(60 * 1000);
        this.startTimer();
      }
    },
    stopTimer() {
      clearInterval(this.timerId);
      this.timerId = -1;
    },
  },
};
</script>

<style scoped>
.stats-page {
    position: fixed;
    padding: 20px;
    height: 100%;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    z-index: 999999999;
    background: var(--bg);
    width: 100%;
}

h1 {
    margin-top: 48px;
    font-weight: 500;
    font-size: 24px;
    letter-spacing: 0.015em;
    margin-bottom: 20px;

}

h2 {
    font-weight: 500;
    font-size: 20px;
    letter-spacing: 0.015em;
    margin-bottom: 20px;

}

.refresh-group {
    display: flex;
    align-items: center;
    justify-content: space-between;
    max-width: max-content;
    margin: 0 auto;
    margin-bottom: 20px;
}

.refresh-btn {
    height: 40px;
    width: 40px;
    background: var(--surface-dark);
    border-radius: var(--border-radius);
    margin-right: 20px;
    background-image: url("data:image/svg+xml,%0A%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%23ffffff' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-refresh-ccw'%3E%3Cpolyline points='1 4 1 10 7 10'%3E%3C/polyline%3E%3Cpolyline points='23 20 23 14 17 14'%3E%3C/polyline%3E%3Cpath d='M20.49 9A9 9 0 0 0 5.64 5.64L1 10m22 4l-4.64 4.36A9 9 0 0 1 3.51 15'%3E%3C/path%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: center;
}

.refresh-btn:active {
    background-color: #9190e3;
}

.table-wrapper {
    position: relative;
    flex: 1;
    overflow: scroll;
    border-radius: var(--border-radius);
    min-height: 150px;
    /* margin-bottom: 80px;* / /* Make the table float above the menu button */
}

.stats-table {
    background-color: rgba(255, 255, 255, 0.2);
    border-radius: var(--border-radius);
    border: none;
    width: 100%;
}

.row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px;
}

.row p:first-child {
    text-align: left;
    overflow-wrap: break-word;
    max-width: 50%;
}

.row p:last-child {
    text-align: right;
    max-width: 50%;
    overflow-wrap: break-word;
}

.stats-table .row {
    background-color: rgba(255, 255, 255, 0.1);
}

.stats-table .row:nth-child(odd) {
    background-color: rgba(255, 255, 255, 0.2);
}

.loading-wrapper {
    position: absolute;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 0.25);
}

.back {
    background-color: transparent;
}

.reset-btn {
    background-color: var(--surface-dark);
    border-radius: var(--border-radius);
    padding: 10px 20px;
    margin-bottom: 20px;
    margin-top: 20px;
    align-self: center;
    font-size: 16px;
    font-weight: 500;
    color: var(--text);
    border: none;
}
</style>
